import React from "react";
// import { Context } from "../models/Context";
import { getBuildNumber, getStorage, getVersion, setBuildNumber, setStorage, setVersion } from "../.././Services/common/Storage";
import { EncryptDecryptService } from "./EncryptionService";
import { ContextModel } from "../../shared/Modal/ContextModel";

const edService = new EncryptDecryptService();
let token = "";

function extractHeaders(response: Response) {
  return response.headers;
}

async function handleVersioning(header: Headers) {
  try {
    const apiVersion = header.get("X-Version")!.toString();
    const isLogout = header.get("X-Access")!.toString();

    const curVersion = getVersion();

    if (curVersion !== null && curVersion !== undefined && curVersion !== "") {
      if (+apiVersion !== +curVersion) {
        setVersion(apiVersion);
        caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
        window.location.reload();
        if (isLogout === "true") setStorage(new ContextModel());
      }
    } else {
      setVersion(apiVersion);
      caches.keys().then((names) => names.forEach((n) => caches.delete(n)));
      window.location.reload();
    }
  } catch (e: any) {
    /* noop */
  }
}

export const POST_ENC = async (
  url: string,
  data: any = null,
  isFormData: boolean = false,
  fileToken: string = "",
  encryptResponse: boolean = true,
  encryptRequest: boolean = true
) => {
  try {
    const localStorage = getStorage();
    if (localStorage?.token) token = localStorage.token || "";

    const headers: any = {};
    if (isFormData) {
      headers.Authorization = token ? `Bearer ${token}` : "";
      headers.Accept = "*/*";
    } else {
      headers.Authorization = token ? `Bearer ${token}` : "";
      headers.Accept = "application/json";
      headers["Content-Type"] = "application/json";
    }

    if (encryptRequest) headers["X-Encrypt-Request"] = "true";
    if (fileToken) headers.Authorization = fileToken ? `Bearer ${fileToken}` : "";

    let bodyToSend: any = null;
    if (!isFormData) {
      if (encryptRequest) {
        try {
          // Prefer server-format encryption (C# backend: base64(IV||cipher) with key/iv from EncryptKey substrings)
          if (typeof (edService as any).encryptServerFormat === "function") {
            const enc = await (edService as any).encryptServerFormat(data, edService.EncryptKey);
            bodyToSend = JSON.stringify({ _payload: enc });
          } else if (typeof (edService as any).encryptForBackend === "function") {
            const enc = await (edService as any).encryptForBackend(data, edService.EncryptKey);
            bodyToSend = JSON.stringify({ _payload: enc });
          } else {
            const enc = edService.encryptObject(data);
            bodyToSend = JSON.stringify({ _payload: enc });
          }
        } catch (e: any) {
          bodyToSend = JSON.stringify(data);
        }
      } else {
        bodyToSend = JSON.stringify(data);
      }
    } else {
      bodyToSend = data;
    }

    const response = await fetch(url, {
      method: "POST",
      headers,
      body: isFormData ? data : bodyToSend,
    });

    const header = extractHeaders(response);
    await handleVersioning(header);
    const body = await response.json();
    const responseJson: any = { ok: response.ok, status: response.status, statusText: response.statusText, header, data: body };
    if (encryptResponse && responseJson.data && (responseJson.data._payload || responseJson.data.Data)) {
      try {
        // Prefer server-format decryption first (matches backend C# `Encrypt/Decrypt`)
        const encValue = responseJson.data._payload ?? responseJson.data.Data;
        let dec: string | undefined = undefined;
        if (typeof (edService as any).decryptServerFormat === "function") {
          dec = await (edService as any).decryptServerFormat(encValue, edService.EncryptKey);
        }
        if (dec === undefined && typeof (edService as any).decryptFromBackend === "function") {
          dec = await (edService as any).decryptFromBackend(encValue, edService.EncryptKey);
        }
        if (dec === undefined) {
          const decrypted = edService.decryptToObject(encValue);
          if (decrypted !== undefined) {
            responseJson.data.data = decrypted;
            delete responseJson.data.Data;
            delete responseJson.data._payload;
          }
        } else {
          try {
            responseJson.data.data = JSON.parse(dec);
          } catch (e: any) {
            responseJson.data.data = dec;
          }
          delete responseJson.data.Data;
          delete responseJson.data._payload;
        }
      } catch (e: any) {
        /* noop */
      }
    }

    if (!responseJson.ok) {
      if (responseJson.data?.data) {
        throw responseJson.data?.data;
      } else throw responseJson.statusText;
    }
    return responseJson.data.data !== undefined ? responseJson.data.data : responseJson.data;
  } catch (error) {
    throw error;
  }
};

export const GET_ENC = async (
  url: string,
  params: any = null,
  signal?: AbortSignal,
  encryptResponse: boolean = true
) => {
  try {
    const localStorage = getStorage();
    if (localStorage?.token) token = localStorage.token || "";

    const headers: any = {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    if (encryptResponse) headers["X-Encrypt-Request"] = "true";
    const response = await fetch(url, { method: "GET", headers, signal });
    const header = extractHeaders(response);
    await handleVersioning(header);

    const body = await response.json();
    const responseJson: any = { ok: response.ok, status: response.status, statusText: response.statusText, header, data: body };
    if (encryptResponse && responseJson.data && (responseJson.data._payload)) {
      try {
        const encValue = responseJson.data._payload ?? responseJson.data.Data;
        let dec: string | undefined = undefined;
        if (typeof (edService as any).decryptServerFormat === "function") {
          dec = await (edService as any).decryptServerFormat(encValue, edService.EncryptKey);
        }
        if (dec === undefined && typeof (edService as any).decryptFromBackend === "function") {
          dec = await (edService as any).decryptFromBackend(encValue, edService.EncryptKey);
        }
        if (dec === undefined) {
          const decrypted = edService.decryptToObject(encValue);
          if (decrypted !== undefined) {
            responseJson.data.data = decrypted;
            delete responseJson.data.Data;
            delete responseJson.data._payload;
          }
        } else {
          try {
            responseJson.data.data = JSON.parse(dec);
          } catch (e: any) {
            responseJson.data.data = dec;
          }
          delete responseJson.data.Data;
          delete responseJson.data._payload;
        }
      } catch (e: any) {
        /* noop */
      }
    }

    if (!responseJson.ok) {
      if (responseJson.data) {
        throw responseJson.data;
      } else throw responseJson.statusText;
    }

    return responseJson.data !== undefined ? responseJson.data : responseJson.data;
  } catch (error) {
    throw error;
  }
}; 